export class Favorite {
  id?: string;
  userId?: string;
  resourceId?: string;
  resourceType?: string;
  resourceName?: string;
  resourceUrl?: string;
  thumbnailColor?: string;
  createdAt?: string;
  icon?: string;
  image?: string;
}

export class FavoriteDTO extends Favorite {
  isFavorite?: boolean;
}
